import { HttpService } from "@root/services/http";
import { getBaseUrl } from "@root/store/selectors/features";
import { store } from "@root/store";
import axios from "axios";
import { HTTP_TIMEOUT_DURATION } from "@root/constants/auth";

export class OrganizationsService extends HttpService {
  baseUrl = getBaseUrl(store.getState());

  // Get all organizations
  fetchOrganizations = async (payload?: any): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/admin/organizations`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  // Get organization by ID
  fetchOrganization = async (id: string | number): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/admin/organizations/${id}`;
    try {
      const apiResponse = await this.get(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  // Create organization
  createOrganization = async (payload: FormData): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/admin/organizations`;
    try {
      // Get headers from HttpService (includes auth token and language)
      const headers = await this.getHeaders();
      // Remove Content-Type to let axios automatically set multipart/form-data with boundary for FormData
      delete headers["Content-Type"];
      
      const apiResponse = await axios.post(baseUrl, payload, {
        headers,
        timeout: HTTP_TIMEOUT_DURATION,
      });
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  // Update organization
  updateOrganization = async (
    id: string | number,
    payload: FormData
  ): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/admin/organizations/${id}`;
    try {
      // Get headers from HttpService (includes auth token and language)
      const headers = await this.getHeaders();
      // Remove Content-Type to let axios automatically set multipart/form-data with boundary for FormData
      delete headers["Content-Type"];
      
      const apiResponse = await axios.put(baseUrl, payload, {
        headers,
        timeout: HTTP_TIMEOUT_DURATION,
      });
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  // Delete organization
  deleteOrganization = async (id: string | number): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/admin/organizations/${id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
